import { FC, useState, useMemo } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useQuery } from 'react-query';
import { Search } from 'components/Search';
import { Grid, Paper } from '@material-ui/core';
import { GridColumns, GridCellParams, DataGrid } from '@material-ui/data-grid';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import EmailIcon from '../../../assets/icons/EndUser/Email.svg';
import { getRowsPerPageOptions } from 'utils/pagination';
import { toFormatDateTime } from 'utils';
import { TabsEditRequestProps } from './types';
export const InviteTable: FC<TabsEditRequestProps> = observer(({ newRequests }) => {
  const {
    inviteTableStore: { setFilter, getInviteEmail, inviteView, getInvitePassword, passwordView },
    notificationStore: { openNotification },
  } = useStore();
  const classes = useStyles();
  const getInviteEmailReq = useQuery('getInviteEmail', () => getInviteEmail(), {
    onError: (error: Error) => openNotification('error', error.message),
  });
  const getInvitePasswordReq = useQuery('getInvitePassword', () => getInvitePassword(), {
    onError: (error: Error) => openNotification('error', error.message),
  });
  useAppPreloader(getInviteEmailReq.isFetching || getInvitePasswordReq.isFetching);
  const rows = useMemo(() => {
    if (newRequests) {
      return !getInviteEmailReq.isFetching ? inviteView : [];
    } else {
      return !getInvitePasswordReq.isFetching ? passwordView : [];
    }
  }, [inviteView, getInviteEmailReq.isFetching, newRequests, getInvitePasswordReq.isFetching, passwordView]);
  const [pageSize, setPageSize] = useState(10);
  const rowsPerPageOptions = useMemo(() => getRowsPerPageOptions(rows), [rows]);
  const columns: GridColumns = [
    {
      field: 'created_at',
      headerName: 'CREATED',
      flex: 0.6,
      valueGetter: (params) => toFormatDateTime(params.row.created_at),
    },
    {
      field: 'updated_at',
      headerName: 'LAST UPDATED',
      flex: 0.6,
      valueGetter: (params) => toFormatDateTime(params.row.updated_at),
    },
    {
      field: 'email',
      headerName: 'SENT TO',
      flex: 0.6,
      renderCell: (params: GridCellParams) => {
        const value = String(params.value ?? '');
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            <img src={EmailIcon} alt='' />
            {value}
          </div>
        );
      },
    },
    {
      field: 'sent',
      headerName: 'STATUS',
      flex: 0.7,
      renderCell: (params: GridCellParams) => (
        <div style={{ color: params.row.sent === true ? 'green' : 'red' }}>
          {params.row.sent === true ? 'Sent' : 'Pending'}
        </div>
      ),
    },
  ];
  return (
    <>
      <Grid container justify='space-between' alignItems='center' className={classes.box}>
        <Search handelSearch={setFilter} />
      </Grid>
      <Paper className={classes.dataGrid} elevation={0}>
        <DataGrid
          className={classes.noBorder}
          autoHeight
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          rowsPerPageOptions={rowsPerPageOptions}
          pagination
          onPageChange={(params) => setPageSize(params.pageSize)}
        />
      </Paper>
    </>
  );
});
